import React, { useState, useEffect } from "react";
import Modal from "@/app/core/layouts/main/components/Modal";
import { CheckCreditCard, Countries, GetCardBrand, States } from "@/app/core/util/helpers/MoneyHelper";
import { toast } from "react-toastify";
import InputMask from "react-input-mask";
import Storage from "@/app/core/util/Storage";
import { CardsController } from "@/app/core/base/controllers/CardsController";
import { FieldTypeObj } from "@/app/core/util/helpers/FieldTypeHelper";
import OnDataChange from "@/app/core/util/helpers/HandleChange";
import Translate, { Message } from "@/app/core/util/messages/GeralMessages";
import { GlobalController } from "@/app/core/base/controllers/GlobalController";
import { Typeahead } from "react-bootstrap-typeahead";

export default function CreditCardModal({ show, onHide }) {
  const userData = Storage.getUserData();
  const [data, setData] = useState(CardsController.BaseModel);
  const [loading, setLoading] = useState(false);
  const [query, setQuery] = useState("");
  const date = new Date();
  const [change, setChange] = useState(date.getTime());

  useEffect(() => { }, [show]);

  function onSubmit(e) {
    e.preventDefault();
    save();
  }

  function notifyChange() {
    setChange(date.getTime());
  }

  function handleChange(evt, type) {
    setData(OnDataChange(data, evt, type));
  }

  function handleAddressChange(evt, type) {
    if (evt.target.name == "zipCode" && evt.target.value.length >= 8) {
      loadAddress(evt.target.value)
    } else {
      setData({ ...data, billingAddress: OnDataChange(data.billingAddress, evt, type) });
    }
  }

  function loadAddress(zipCode) {
    setLoading(true);
    GlobalController.GetAddress(zipCode, res => {
      let address = data.billingAddress;
      address.city = res.localidade;
      address.state = res.uf;
      address.line2 = res.complemento;
      address.line1 = `${res.logradouro} ${res.bairro}`;
      address.zipCode = zipCode;

      setData({ ...data, billingAddress: address });
      notifyChange();
    })
    setLoading(false);
  }

  async function save() {
    setLoading(true);
    if (checkFields()) {
      if (!CheckCreditCard(data.number)) {
        toast.error(Translate(Message.Payment.InvalidCardNumber));
        return;
      }

      let base = data;
      base.brand = GetCardBrand(data.number);

      await CardsController.Insert(data, res => {
        toast.success(Translate(Message.Saved));
        onHide();
      })

    } else {
      toast.error(Translate(Message.PendingData));
    }
    setLoading(false);
  }

  function checkFields() {
    let res = true;

    if (data.number === undefined || data.number === "") {
      res = false;
    }
    if (data.holderName === undefined || data.holderName === "") {
      res = false;
    }
    if (data.expMonth === undefined || data.expMonth === "") {
      res = false;
    }
    if (data.expYear === undefined || data.expYear === "") {
      res = false;
    }
    if (data.cvv === undefined || data.cvv === "") {
      res = false;
    }
    return res;
  }

  return (
    <Modal
      title="Cartão de crédito"
      show={show}
      isLoading={loading}
      onHide={onHide}
      onSubmit={() => save()}
    >
      <form className="js-validation-signin" onSubmit={(e) => onSubmit(e)}>
        <div className="form-group text-center py-3 row">
          <div className="col-3"></div>
          <div className="col-6">

            <img src="assets/media/credit-card.png" />
            <div
              style={{
                marginTop: -150,
                padding: 80,
              }}
            >
              <div className="row text-white font-size-sm">
                <div className="col-12 text-left">
                  {data.number !== "" ? data.number : "0000 0000 0000 0000"}
                </div>
                <div className="col-8 text-left">
                  {data.name !== "" ? data.name : "Nome S. Sobrenome"}
                </div>
                <div className="col-4 text-right">
                  {data.venc !== "" ? data.venc : "MM/AA"}
                </div>
              </div>
            </div>
          </div>
          <div className="col-3"></div>
        </div>
        <div className="form-group">
          <span>{Translate(Message.Payment.EnterCreditCard)}</span>
          <InputMask
            mask="9999 9999 9999 9999"
            maskChar=""
            type="text"
            className="form-control"
            id="advanced-filter-document"
            name="number"
            placeholder={Translate(Message.Payment.EnterCreditCard)}
            onChange={(event) => {
              handleChange({
                target: {
                  name: "number",
                  value: event.target.value.replace(/\D/g, ""),
                },
              });
            }}
          />
        </div>

        <div className="row">
          <div className="col-3">
            <div className="form-group text-center">
              <span>{Translate(Message.Payment.ExpirationMonth)}</span>
              <input
                className="form-control"
                id="advanced-filter-document"
                name="expMonth"
                value={data.expMonth}
                placeholder={Translate(Message.Payment.ExpirationMonth)}
                onChange={(evt) => handleChange(evt, FieldTypeObj.Number)}
              />
            </div>
          </div>
          <div className="col-3">
            <div className="form-group">
              <span>{Translate(Message.Payment.ExpirationYear)}</span>
              <input
                className="form-control"
                id="advanced-filter-document"
                name="expYear"
                value={data.expYear}
                placeholder={Translate(Message.Payment.ExpirationYear)}
                onChange={(evt) => handleChange(evt, FieldTypeObj.Number)}
              />
            </div>
          </div>
          <div className="col-6">
            <div className="form-group">
              <span>CVV</span>
              <InputMask
                mask="999"
                maskChar=""
                type="text"
                className="form-control"
                id="advanced-filter-document"
                name="cvv"
                placeholder="CVV"
                onChange={(event) => {
                  handleChange({
                    target: {
                      name: "cvv",
                      value: event.target.value,
                    },
                  }, FieldTypeObj.Number);
                }}
              />
            </div>
          </div>
          <div className="col-6">
            <div className="form-group">
              <span>{Translate(Message.Payment.Holder)}</span>
              <input
                className="form-control"
                id="advanced-filter-document"
                name="holderName"
                value={data.holderName}
                placeholder={Translate(Message.Payment.Holder)}
                onChange={(evt) => handleChange(evt)} />
            </div>
          </div>
          <div className="col-6">
            <div className="form-group">
              <span>{Translate(Message.Payment.HolderDoc)}</span>
              <input
                className="form-control"
                id="advanced-filter-document"
                name="holderDocument"
                value={data.holderDocument}
                placeholder={Translate(Message.Payment.HolderDoc)}
                onChange={(evt) => handleChange(evt)} />
            </div>
          </div>
          <div className="col-6">
            <div className="form-group">
              <span>{Translate(Message.PostalCode)}</span>
              <input
                className="form-control"
                id="advanced-filter-document"
                name="zipCode"
                value={data.billingAddress.zipCode}
                placeholder={Translate(Message.PostalCode)}
                onChange={(evt) => handleAddressChange(evt)} />
            </div>
          </div>
          <div className="col-6">
            <div className="form-group">
              <span>{Translate(Message.Address)}</span>
              <input
                className="form-control"
                id="advanced-filter-document"
                name="line1"
                value={data.billingAddress.line1}
                placeholder={Translate(Message.Address)}
                onChange={(evt) => handleAddressChange(evt)} />
            </div>
          </div>
          <div className="col-6">
            <div className="form-group">
              <span>Complemento</span>
              <input
                className="form-control"
                id="advanced-filter-document"
                name="line2"
                value={data.billingAddress.line2}
                placeholder="Complemento"
                onChange={(evt) => handleAddressChange(evt)} />
            </div>
          </div>
          <div className="col-6">
            <div className="form-group">
              <span>Cidade</span>
              <input
                className="form-control"
                id="advanced-filter-document"
                name="city"
                value={data.billingAddress.city}
                placeholder="Cidade"
                onChange={(evt) => handleAddressChange(evt)} />
            </div>
          </div>
          <div className="col-6">
            <div className="form-group">
              <span>Estado</span>
              <input
                options={States}
                labelKey={(option) => `(${option.ShortName}) ${option.LongName}`}
                onSearch={(q) => setQuery(q)}
                className="form-control"
                name="state"
                placeholder="Ex: SP"
                onChange={evt => handleAddressChange(evt)}
              />
            </div>
          </div>
          <div className="col-6">
            <div className="form-group">
              <span>País</span>
              <Typeahead
                options={Countries}
                labelKey={(option) => `(${option.Code}) ${option.Name}`}
                onSearch={(q) => setQuery(q)}
                name="state"
                placeholder="Selecionar"
                onChange={(selected) => {
                  if (selected[0] !== undefined || selected !== null) {
                    handleAddressChange({ target: { value: selected[0].Code, name: "country" } });
                  }
                }}
              />
            </div>
          </div>
        </div>
      </form>
    </Modal>
  );
}
